import { Navigate } from 'react-router-dom';

const Home = () => {
  return <Navigate to="/dashboard" />;
};

export default Home;
